module.exports = __webpack_public_path__ + "static/media/parrot2.53dcfa88.svg";